import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../layout/table";
import { search as getCourts } from "../../actions/courts";
import { only as numbersOnly } from "../../utils/number";
import { phone } from "../../utils/string";

import ConditionalButton from "../../layout/conditional-button";
import { send as pageInfo, loading } from "../../actions/page";
import { withNavigation } from "../../utils/wrapper";

class Courts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "name",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            archived: 0,
            converted: 0
        };
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    }


    loadData = async () => {
        this.props.loading(true);
        
        let { page, size, order, direction, search } = this.state;

        const __data = await this.props.getCourts({ page, size, order, direction, search });
        let __count = 0;

        if (__data?.items?.length > 0)
            __count = Math.ceil(Number(__data.count) / Number(size));

        this.setState({
            ...this.state,
            data: __data.items,
            pages: __count
        });

        await this.props.pageInfo({ title: "Courts", breadcrumb: `Courts` });
        this.props.loading(false);

    }


    get headers() {        
        return [
            {
                header: "Name",
                sortable: true,
                source: "name",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onNameLinkFormat
            },
            {
                header: "Address",
                sortable: true,
                source: "Address.city",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onAddressLinkFormat
            },
            {
                header: "Phone",
                sortable: true,
                source: "phone",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onPhoneLinkFormat
            },
            {
                header: "Chambers",
                sortable: true,
                source: "chambers",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onPhoneLinkFormat
            }
        ]
    }

    onNameLinkFormat = (e, row) => {
        return this.onLinkFormat(`${row["name"]} (${row["full"]})`, row)
    }

    onAddressLinkFormat = (e, row) => {
        return this.onLinkFormat(`${row["Address.line1"]} ${row["Address.city"]}, ${row["Address.state"]} ${row["Address.zipCode"]}`, row)
    }

    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/courts/${row['uuid']}">${e}</a>`
    }

    onPhoneLinkFormat = (e, row) => {
        if (!e) return "";
        let __phone = numbersOnly(e);
        if (__phone === "1") return "";
        return `<a href="tel:+${__phone}">${phone(__phone)}</a>`
    }

    onColumnClick = (e) => {
        const __array = this.headers;
        const __index = __array.findIndex((item) => {
            return item.header === e.header && item.source === e.source;
        });

        this.setState({
            index: __index,
            direction: this.state.index === __index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: __array[__index].source,
            page: 0
        }, this.loadData);

    }

    onSearch = (e) => {
        this.setState({
            search: e
        }, this.loadData);
    }

    onSize = (e) => {
        this.setState({
            page: 0,
            size: Number(e)
        }, this.loadData);
    }

    onPageChange = (e) => {
        this.setState({
            page: Number(e)
        }, this.loadData);
    }

    onNewClick = (e) => {
        this.props.navigate("add");
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new court" display enabled={true} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchOnEnter={true}
                        searchable={true}
                        sizable={false}
                    />
                </Col>
            </>
        )
    }
}

Courts.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { getCourts, loading, pageInfo })(Courts));
